class Cache {
  constructor() {
    this.cache = [];
  }
  
  add(type, data) {
    var index = this.cache.findIndex(entry => {
      return entry.type === type;
    })
    if (index > -1) {
      this.cache[index].data = data;
    }
    else {
      this.cache.push({type: type, data: data})
    }
  }
  
  get(type) {
    var index = this.cache.findIndex(entry => {
      return entry.type === type;
    })
    if (index > -1) {
      return this.cache[index].data;
    }
    else {
      return null;
    }
  }
}

export default Cache;